import React, { useState, useEffect, memo } from "react";
import { Card, Col, Nav, Row, Table, Placeholder } from "react-bootstrap";
import { VectorMap } from "@react-jvectormap/core";
import { worldMill } from "@react-jvectormap/world";
import { formatThousand } from "@revbox/helpers-fe";

import { getPeriodInventoryInsightsMap } from "../../../../services/micro";
import "../../../../scss/_variables.scss"

function InventoryInsightsMap({ currentPeriod, previousPeriod, inventoryId }) {
  const [response, setResponse] = useState();
  const [reset, setReset] = useState(0);
  const mapStartColor = getComputedStyle(document.documentElement).getPropertyValue('--map-start');
  const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary');

  useEffect(() => {
    if (currentPeriod && previousPeriod) {
      if (currentPeriod[0] && currentPeriod[1] && previousPeriod[0] && previousPeriod[1]) {
        getPeriodInventoryInsightsMap(currentPeriod, previousPeriod, inventoryId).then((response) => {
          if (response) {
            setResponse(response);
          }
        });
      }
    }
  }, [currentPeriod, previousPeriod, inventoryId]);

  const onMapReset = () => {
    setReset(reset + 1);
  };

  if (response) {
    return (
      <React.Fragment key={reset}>
        <Col md="12">
          <Card className="card-one">
            <Card.Header>
              <Card.Title as="h6">Views & Clicks By Country</Card.Title>
              <Nav className="nav-icon nav-icon-sm ms-auto">
                <Nav.Link href="" onClick={onMapReset}>
                  <i className="ri-refresh-line"></i>
                </Nav.Link>
              </Nav>
            </Card.Header>
            <Card.Body>
              <Row className="align-items-center g-3">
                <Col
                  md="4"
                  className="d-flex flex-column justify-content-center"
                >
                  <Table className="table-one mb-4">
                    <thead>
                      <tr>
                        <th className="wd-40 pt-0">Top Countries</th>
                        <th className="wd-60 pt-0">Views</th>
                        <th className="wd-60 pt-0">Clicks</th>
                      </tr>
                    </thead>
                    <tbody>
                      {response.country_data.slice(0, 7).map((item, index) => (
                        <tr key={index}>
                          <td>
                            <span className="fw-medium">{item.country}</span>
                          </td>
                          <td>{formatThousand(item.views)}</td>
                          <td>{formatThousand(item.clicks)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Col>
                <Col md="8" className="mt-5 mt-md-0 h-100">
                  <div style={{ height: "300px" }}>
                    <VectorMap
                      map={worldMill}
                      backgroundColor="transparent"
                      regionStyle={{
                        initial: {
                          fill: "#e4e4e4",
                          "fill-opacity": 0.9,
                          stroke: "none",
                          "stroke-width": 0,
                          "stroke-opacity": 0,
                        },
                      }}
                      series={{
                        regions: [
                          {
                            values: response.click_data,
                            scale: [mapStartColor, primaryColor],
                            attribute: "fill",
                          },
                        ],
                      }}
                      onRegionTipShow={(e, el, code) => {
                        el.html(
                          el.html() +
                            " - Clicks: " +
                            (formatThousand(response.click_data[code]) || 0) +
                            " | Views: " +
                            (formatThousand(response.view_data[code]) || 0)
                        );
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <Placeholder as={Card.Title} animation="glow" style={{color: "var(--bs-body-color)"}}>
          <Placeholder style={{ height: 400, width: "100%" }} />
        </Placeholder>
      </React.Fragment>
    );
  }
}

export default memo(InventoryInsightsMap);